// scripts/filter-category-table.js
// Dynamically load jQuery and DataTables (if needed), inject a 3-column
// table into `.filter-category-table`, populate it from available project
// data and initialize DataTables. This file is intended to be included via
// a <script> tag in index.html (Option B requested by user).
(function () {
  'use strict';

  const CDN = {
    jquery: { url: 'https://code.jquery.com/jquery-3.6.0.min.js', integrity: 'sha384-vtXRMe3mGCbOeY7l30aIg8H9p3GdeSe4IFlP6G8JMa7o7lXvnz3GFKzPxzJdPfGK', crossorigin: 'anonymous' },
    datatables_css: { url: 'https://cdn.datatables.net/1.13.6/css/dataTables.bootstrap5.min.css', integrity: 'sha384-5oFfLntNy8kuC2TaebWZbaHTqdh3Q+7PwYbB490gupK0YtTAB7mBJGv4bQl9g9rK', crossorigin: 'anonymous' },
    datatables_js: { url: 'https://cdn.datatables.net/1.13.6/js/jquery.dataTables.min.js', integrity: 'sha384-k5vbMeKHbxEZ0AEBTSdR7UjAgWCcUfrS8c0c5b2AfIh7olfhNkyCZYwOfzOQhauK', crossorigin: 'anonymous' },
    datatables_bs5_js: { url: 'https://cdn.datatables.net/1.13.6/js/dataTables.bootstrap5.min.js', integrity: 'sha384-PgPBH0hy6DTJwu7pTf6bkRqPlf/+pjUBExpr/eIfzszlGYFlF9Wi9VTAJODPhgCO', crossorigin: 'anonymous' }
  };

  function loadScript(url) {
    // Accept either a string URL or an object { url, integrity, crossorigin }
    return new Promise((resolve, reject) => {
      try {
        const s = document.createElement('script');
        const src = (typeof url === 'string') ? url : (url && url.url ? url.url : '');
        s.src = src;
        if (url && url.integrity) s.integrity = url.integrity;
        if (url && url.crossorigin) s.crossOrigin = url.crossorigin;
        // Load scripts synchronously in insertion order to avoid race conditions
        // (we still await onload in the caller).
        s.async = false;
        s.onload = () => resolve();
        s.onerror = (e) => reject(e || new Error('Failed to load ' + src));
        document.head.appendChild(s);
      } catch (e) { reject(e); }
    });
  }
  // Ensure the init runs when the container exists or is later inserted into the DOM
  function ensureInitWhenReady() {
    // Observe the document for later insertions of the filter container (map-ui may replace parts)
    const obs = new MutationObserver((mut) => {
      for (const m of mut) {
        for (const n of Array.from(m.addedNodes || [])) {
          try {
            if (!(n instanceof HTMLElement)) continue;
            if (n.classList && n.classList.contains && n.classList.contains('filter-category-table')) {
              try { init(); } catch (e) {}
              return;
            }
            if (n.querySelector && n.querySelector('.filter-category-table')) {
              try { init(); } catch (e) {}
              return;
            }
          } catch (e) {}
        }
      }
    });
    try { obs.observe(document.documentElement || document.body, { childList: true, subtree: true }); } catch (e) { setTimeout(init, 300); }
    // If the container already exists, attempt an init now as well.
    try { if (document.querySelector('.filter-category-table')) init(); } catch (e) { /* ignore */ }
  }

  function loadCss(url) {
    // Accept either a string href or an object { url, integrity, crossorigin }
    return new Promise((resolve, reject) => {
      try {
        const l = document.createElement('link');
        l.rel = 'stylesheet';
        const href = (typeof url === 'string') ? url : (url && url.url ? url.url : '');
        l.href = href;
        if (url && url.integrity) l.integrity = url.integrity;
        if (url && url.crossorigin) l.crossOrigin = url.crossorigin;
        l.onload = () => resolve();
        l.onerror = (e) => reject(e || new Error('Failed to load ' + href));
        document.head.appendChild(l);
      } catch (e) { reject(e); }
    });
  }

  function findProjects() {
    // Try several globals that may contain project rows.
    if (window && Array.isArray(window.__allProjects) && window.__allProjects.length) return window.__allProjects;
    if (window && Array.isArray(window.projects) && window.projects.length) return window.projects;
    if (window && Array.isArray(window.projectRows) && window.projectRows.length) return window.projectRows;
    if (window && Array.isArray(window.schoolRows) && window.schoolRows.length) {
      // schoolRows is not projects; try to map if projects are attached to schoolRows entries
      const mapped = [];
      window.schoolRows.forEach(s => {
        try {
          const p = s && s.projects;
          if (Array.isArray(p)) mapped.push(...p);
        } catch (e) {}
      });
      if (mapped.length) return mapped;
    }
    return [];
  }

  // function createTableHtml(id) {
  //   // Use Bootstrap table classes for a compact, native Bootstrap look inside the offcanvas
  //   // Fixed column widths are applied via <colgroup> and table-layout:fixed so
  //   // DataTables respects the widths inside the offcanvas side panel.
  //   // Column widths chosen to fit a typical 480px side panel (adjust if needed).
  //   return `<table id="${id}" class="table table-sm table-striped table-bordered" style="width:100%;">
  //     <colgroup>
  //       <col style="width:210px" />
  //       <col style="width:140px" />
  //       <col style="width:80px" />
  //     </colgroup>
  //     <thead><tr><th>School</th><th>Category</th><th>Year</th></tr></thead><tbody></tbody></table>`;
  // }
  function createTableHtml(id) {
    return `<table id="${id}" class="table table-sm table-striped table-bordered" style="width:100%;">
      <colgroup>
        <col style="width:260px" />
        <col style="width:240px" />
      </colgroup>
      <thead><tr><th>School</th><th>Category</th></tr></thead><tbody></tbody></table>`;
  }

  function normalizeProjectRow(p) {
    const school = p?.['Campus'] ?? p?.['School Name'] ?? p?.['Campus/School'] ?? p?.school ?? '';
    const category = p?.['Category'] ?? p?.['Project Category'] ?? p?.['Project Type'] ?? p?.Type ?? p?.category ?? '';
    //const year = p?.['Year of Rennovation'] ?? p?.['Year of Renovation'] ?? p?.['Years'] ?? p?.Year ?? p?.['Planned Year'] ?? p?.['Schedule Year'] ?? p?.Years ?? p?.year ?? '';
    //return [String(school ?? '').trim(), String(category ?? '').trim(), String(year ?? '').trim()];
    return [String(school ?? '').trim(), String(category ?? '').trim()];
  }

  function escapeHtml(s) {
    if (s == null) return '';
      return String(s).replace(/[&<>"']/g, function (m) {
        return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[m];
      });

  }

  async function init() {
    try {
      // Wait for the filter-summary container to exist or the .filter-category-table
      let container = document.querySelector('.filter-category-table');
      // If the container doesn't exist yet (summary may not be rendered), try to create a fallback
      if (!container) {
        try {
          const parent = document.getElementById('filterSummaryContainer') || document.querySelector('.offcanvas .offcanvas-body') || document.getElementById('sidePanel') || document.body;
          if (parent) {
            const el = document.createElement('div');
            el.className = 'filter-category-table';
            parent.appendChild(el);
            container = el;
          }
        } catch (e) { /* ignore creation errors */ }
      }
      if (!container) return; // nothing to do

      // Load styles first, but skip if the same CSS is already present on the page
      try {
        const cssAlready = !!document.querySelector('link[href*="dataTables.bootstrap5.min.css"]');
        if (!cssAlready) {
          await loadCss(CDN.datatables_css);
        }
  } catch (e) { console.warn('filter-category-table: datatables CSS failed to load', e); }

      // Ensure jQuery + DataTables present
      // Load jQuery only when missing (app may already include it)
      if (!window.jQuery) {
        try { await loadScript(CDN.jquery); } catch (e) { console.warn('filter-category-table: Failed to load jQuery for DataTables', e); }
      }

      // Load DataTables core only if the plugin isn't registered yet
      const dataTablesPresent = !!(window.jQuery && window.jQuery.fn && window.jQuery.fn.dataTable);
      if (!dataTablesPresent) {
        try { await loadScript(CDN.datatables_js); } catch (e) { console.warn('filter-category-table: Failed to load DataTables', e); }
      }

      // Load the Bootstrap 5 integration only if not already present as a script tag
      try {
        const bsIntegrationPresent = !!document.querySelector('script[src*="dataTables.bootstrap5.min.js"]');
        if (!bsIntegrationPresent) {
          try { await loadScript(CDN.datatables_bs5_js); } catch (e) { console.warn('filter-category-table: DataTables Bootstrap5 integration failed to load', e); }
        } else {
          // integration already present; nothing to do
        }
      } catch (e) { /* ignore */ }

      // Respect explicit context if set (e.g., single-school event)
      const ctx = (window && window.__filterCategoryTableContext) ? window.__filterCategoryTableContext : null;
      // If a single-school handler recently locked the container, skip the generic init
      try {
        if (container && container.dataset && container.dataset.__filterCategoryLocked) {
          const lockedName = (container.dataset.__filterCategoryLockName || '').toString();
          if (!(ctx && ctx.schoolName && ctx.schoolName.toString() === lockedName)) {
            return;
          }
        }
      } catch (e) {}

      const tblId = 'filterCategoryTable';
      // Destroy any existing DataTable instance on this element to avoid reinitialization errors
      try {
        const existingTbl = container.querySelector('#' + tblId);
        if (existingTbl && window.jQuery && window.jQuery.fn && window.jQuery.fn.dataTable) {
          try { if (window.jQuery.fn.dataTable.isDataTable && window.jQuery.fn.dataTable.isDataTable(existingTbl)) { window.jQuery(existingTbl).DataTable().clear().destroy(true); } } catch (e) {}
        }
      } catch (e) {}

      container.innerHTML = createTableHtml(tblId);

      // Populate rows from projects (use context.projects when present)
      const projects = (ctx && Array.isArray(ctx.projects) && ctx.projects.length) ? ctx.projects : findProjects();
      
      const tbody = container.querySelector('#' + tblId + ' tbody');
      if (!tbody) return;
      const rows = (projects || []).map(normalizeProjectRow).filter(r => r && r[0]);
      const seen = new Set();
      rows.forEach(r => {
        try {
          const key = r.join('||');
          if (seen.has(key)) return;
          seen.add(key);
          const tr = document.createElement('tr');
          //tr.innerHTML = `<td>${escapeHtml(r[0])}</td><td>${escapeHtml(r[1])}</td><td>${escapeHtml(r[2])}</td>`;
          tr.innerHTML = `<td>${escapeHtml(r[0])}</td><td>${escapeHtml(r[1])}</td>`;
          tbody.appendChild(tr);
        } catch (e) {}
      });

      // Initialize DataTable if available (destroy existing instance first as extra safety)
      try {
        if (window.jQuery && window.jQuery.fn && window.jQuery.fn.dataTable) {
          try {
            if (typeof window.jQuery.fn.dataTable.isDataTable === 'function' && window.jQuery.fn.dataTable.isDataTable('#' + tblId)) {
              try { window.jQuery('#' + tblId).DataTable().clear().destroy(true); } catch (e) {}
            }
          } catch (e) {}

          
          window.jQuery('#' + tblId).DataTable({
            paging: true,
            pageLength: 10,
            searching: true,
            info: true,
            responsive: true,
            //columns: [ { width: '50%' }, { width: '35%' }, { width: '15%' } ],
            columns: [ { width: '60%' }, { width: '40%' } ],
            dom: "<'row mb-2 gap-0'<'col-sm-5'l><'col-sm-7'f>>" + "<'row'<'col-12't>>" + "<'row mt-2'<'col-sm-12'i><'col-sm-12'p>>",
            language: {
              search: "",
              searchPlaceholder: "Search",
              paginate: {
                previous: '<span aria-hidden="true">«</span></span><span class="visually-hidden">Previous</span>',
                next: '<span aria-hidden="true">»</span><span class="visually-hidden">Next</span>'
              }
            }
          });
          // Accessibility: ensure the generated search <label> contains readable text
          // even though we hide the visible label via language.search = "". Some
          // accessibility linters flag an empty <label> as problematic. Insert a
          // visually-hidden span with a descriptive name so screen readers announce
          // the control while the visual appearance remains unchanged.
          try {
            const searchLabel = container.querySelector('#' + tblId + '_filter label');
            if (searchLabel) {
              if (!searchLabel.textContent || !searchLabel.textContent.trim()) {
                const vh = document.createElement('span');
                vh.className = 'visually-hidden';
                vh.textContent = 'Search projects';
                // Insert at the start so it's associated with the label
                searchLabel.insertBefore(vh, searchLabel.firstChild);
              }
            }
          } catch (e) { /* ignore accessibility insertion errors */ }
          // Accessibility: associate the DataTables length control label with its select
          try {
            const lengthWrapper = container.querySelector('#' + tblId + '_length');
            if (lengthWrapper) {
              const lengthLabel = lengthWrapper.querySelector('label');
              const lengthSelect = lengthWrapper.querySelector('select');
              if (lengthSelect) {
                if (!lengthSelect.id) lengthSelect.id = tblId + '_length_select';
                if (lengthLabel && lengthLabel.htmlFor !== lengthSelect.id) lengthLabel.htmlFor = lengthSelect.id;
                if (!lengthSelect.getAttribute('aria-label')) lengthSelect.setAttribute('aria-label', 'Rows per page');
              }
            }
          } catch (e) { /* ignore */ }
          // Accessibility: insert an sr-only heading into the DataTables wrapper
          // immediately before the top row element (.row.mb-2.gap-0).
          try {
            const wrapper = container.querySelector('.dataTables_wrapper.dt-bootstrap5.no-footer');
            if (wrapper && !wrapper.querySelector('#categoryDetailsHeading')) {
              const topRow = wrapper.querySelector('.row.mb-2.gap-0');
              const h3 = document.createElement('h3');
              h3.id = 'categoryDetailsHeading';
              h3.className = 'sr-only';
              h3.textContent = 'Category Table';
              if (topRow && topRow.parentNode) {
                topRow.parentNode.insertBefore(h3, topRow);
              } else {
                // fallback: prepend to wrapper
                wrapper.insertBefore(h3, wrapper.firstChild);
              }
            }
          } catch (e) { /* ignore heading insertion errors */ }
            
        }
  } catch (e) { try { window.__appLogError && window.__appLogError('DataTable init failed', e); } catch (err) { } }
    } catch (e) {
      // do not throw - keep app stable
      console.error('filter-category-table init error', e);
    }
  }
  // Start
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    ensureInitWhenReady();
  } else {
    document.addEventListener('DOMContentLoaded', ensureInitWhenReady);
  }
  // Expose an explicit init hook so other scripts (e.g. dropdown click handler)
  // can request immediate population when the Category option is selected.
    try {
    window.__initFilterCategoryTable = function () {
      try { init(); } catch (e) { /* ignore */ }
    };
    document.addEventListener('filter:category:selected', function () {
      try { if (typeof window.__initFilterCategoryTable === 'function') window.__initFilterCategoryTable(); } catch (e) {}
    });
  // Listen for single-school event: set a short-lived context so init() will use the provided projects
  document.addEventListener('filter:category:school', function (ev) {
      try {
        const detail = ev && ev.detail ? ev.detail : {};
        const schoolName = (detail.name || detail.schoolName || '').toString();
  const projects = Array.isArray(detail.projects) ? detail.projects : [];
        

  // Set global context so init() will favor these projects.
  window.__filterCategoryTableContext = { schoolName: schoolName, projects: projects };

  // Remove any existing table node to guarantee DataTables doesn't keep stale state
  const container = document.querySelector('.filter-category-table');
        if (!container) return;
        const existing = container.querySelector('#filterCategoryTable');
        if (existing) {
          try {
            if (window.jQuery && window.jQuery.fn && window.jQuery.fn.dataTable) {
              window.jQuery(existing).DataTable().clear().destroy(true);
            }
          } catch (e) {}
          existing.remove();
        }

        // Initialize the table using the provided projects
        init();
        // Lock the container so later generic inits (from mutation observer) skip populating the full dataset.
        try {
          container.dataset.__filterCategoryLocked = '1';
          container.dataset.__filterCategoryLockName = schoolName || '';
          // Clear any previous lock timeout
          try { if (window.__filterCategoryLockTimeout) { clearTimeout(window.__filterCategoryLockTimeout); window.__filterCategoryLockTimeout = null; } } catch (e) {}
          // Keep the lock a bit longer (5s) to survive async DOM insertions and inits
          window.__filterCategoryLockTimeout = setTimeout(function () {
            try { if (container) { delete container.dataset.__filterCategoryLocked; delete container.dataset.__filterCategoryLockName; } } catch (e) {}
            try { window.__filterCategoryLockTimeout = null; } catch (e) {}
            try { window.__filterCategoryTableContext = null; } catch (e) {}
          }, 5000);
        } catch (e) {}
  } catch (e) { try { window.__appLogError && window.__appLogError('filter-category-table event handler error', e); } catch (err) { } }
    });
  } catch (e) { /* ignore exposing hook errors */ }
})();
